<template>
  <div id="components-vessel-document">
    <vx-card :title="data.document_name">
      <template slot="actions">
        <vessel-documents-action-dropdown
          :isOfficeDocument="isOfficeDocument"
          @vesselDocumentsAction="vesselDocumentsAction"
        ></vessel-documents-action-dropdown>
      </template>
      <div
        :id="vesselDocumentPictureId"
        class="image-area-wrapper vs-con-loading__container"
      >
        <img
          v-show="!officeIcon"
          @click="showPreview()"
          id="print"
          :src="imgSrc"
          class="image-area"
        />
        <img v-show="officeIcon" @click="download()" :src="officeIcon" class="image-area-office cursor-pointer" />
      </div>
      <light-box v-if="media.length > 0"
        ref="lightbox"
        :media="media"
        :show-light-box="false"
        :show-thumbs="false"
        :show-caption="false"
        :disableScroll="false"
      >
      </light-box>
    </vx-card>
    <dialog-edit-vessel-document
      ref="dialogEditVesselDocument"
      @onUpdate="onUpdate"
    />
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import VesselDocumentsActionDropdown from "@/components/dropdown/VesselDocumentsActionDropdown";
import DialogEditVesselDocument from "@/views/enterprise/management/vessels/vessel-view/components/cardVesselDocuments/components/DialogEditVesselDocument";
import { PrintUtil, DownloadUtil } from "@/utils";
import LightBox from "vue-image-lightbox";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const picApi = AiseaApiFactory.get("picture");
const epvdApi = AiseaApiFactory.get("enterpriseVesselDocument");

export default {
  name: "cardLicense",
  components: {
    VesselDocumentsActionDropdown,
    DialogEditVesselDocument,
    LightBox
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      media: [],
      imgSrc: null,
      vesselId: null,
      dataURI: null,
      imageLoadingStart: false,
      vesselDocumentPictureId: null,
      officeIcon: null
    };
  },
  computed: {
    isOfficeDocument() {
      return this.officeIcon !== null;
    }
  },
  methods: {
    getThumbnailImageSrc() {
      if (!this.imageLoadingStart) {
        this.$vs.loading({
          type: "border",
          container: `#${this.vesselDocumentPictureId}`,
          scale: 0.6
        });
        this.imageLoadingStart = true;
      }
      if (this.data.picture.thumbnail_path) {
        storage
          .child(this.data.picture.thumbnail_path)
          .getDownloadURL()
          .then(url => {
            this.imgSrc = url;
            this.$vs.loading.close(
              `#${this.vesselDocumentPictureId} > .con-vs-loading`
            );
            this.imageLoadingStart = false;
          })
          .catch(error => {
            //FireStoreにサムネイルができるまでリトライ
            if (error.code === "storage/object-not-found") {
              setTimeout(() => {
                this.getThumbnailImageSrc(this.data.picture.thumbnail_path);
              }, 3000);
            }
          });
      } else {
        setTimeout(() => {
          this.$vs.loading.close(
            `#${this.vesselDocumentPictureId} > .con-vs-loading`
          );
          this.imageLoadingStart = false;
          let ext = this.data.picture.original_path.split('.')
          this.officeIcon = ext[1].startsWith("xl")
            ? require("@/assets/images/icons/office/excel.svg")
            : require("@/assets/images/icons/office/word.svg");
        }, 1000);
      }
    },

    getOriginalImageSrc() {
      storage
        .child(this.data.picture.original_path)
        .getDownloadURL()
        .then(url => {
          this.media = [
            {
              src: url
            }
          ];
        })
        .catch(error => {
          if (error.code === "storage/object-not-found") {
            setTimeout(() => {
              this.getOriginalImageSrc();
            }, 3000);
          }
        });
    },

    vesselDocumentsAction(evt) {
      if (evt === "print") {
        this.printVesselDocuments();
        return;
      }
      if (evt === "delete") {
        this.openDeleteConfirm();
        return;
      }
      if (evt === "download") {
        this.download();
        return;
      }
      if (evt === "preview") {
        this.showPreview();
        return;
      }
      if (evt === "edit") {
        this.edit();
      }
    },

    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `船舶書類の削除`,
        text: this.data.document_name + "を削除しますか？",
        acceptText: "削除する",
        cancelText: "キャンセル",
        accept: this.deleteDocument
      });
    },

    showPreview() {
      storage
        .child(this.data.picture.original_path)
        .getDownloadURL()
        .then(response => {
          window.open(response, "_blank");
        });
    },

    async downloadFile(titleError, makeFile) {
      this.$vs.loading();
      try {
        let res = await picApi.download(this.data.picture.id);
        let blob = res.data;
        let reader = new FileReader();
        reader.onload = e => {
          this.dataURI = e.target.result;
          makeFile
            ? DownloadUtil.saveURLs(this.dataURI, this.data.document_name)
            : this.printVesselDocuments();
          this.$vs.loading.close();
        };
        reader.readAsDataURL(blob);
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: titleError,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },

    download() {
      !this.dataURI
        ? this.downloadFile("ダウンロードに失敗しました", true)
        : DownloadUtil.saveURLs(this.dataURI, this.data.document_name);
    },

    printVesselDocuments() {
      if (!this.dataURI) {
        this.downloadFile("プリントに失敗しました", false);
        return;
      }
      this.data.picture.original_path.includes(".pdf")
        ? PrintUtil.printPdf(this.dataURI)
        : PrintUtil.printImage(this.dataURI);
    },

    async deleteDocument() {
      this.$vs.loading();
      try {
        await epvdApi.delete(this.vesselId, this.data.id);
        this.$vs.loading.close();
        this.$vs.notify({
          color: "success",
          title: `${this.data.document_name}を削除しました`,
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$emit("onDelete");
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "削除に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },

    edit() {
      this.$refs.dialogEditVesselDocument.show(this.vesselId, this.data);
    },

    onUpdate() {
      this.$emit("onUpdate");
    }
  },
  created() {
    this.vesselId = this.$route.params.vesselId;
    this.vesselDocumentPictureId = `vessel-document-picture-${this.data.id}`;
  },
  mounted() {
    this.getThumbnailImageSrc();
    this.getOriginalImageSrc();
  }
};
</script>
<style lang="scss">
#components-vessel-document {
  height: 100%;
  > .vx-card {
    height: 100%;
  }
  .image-area-wrapper {
    height: 15rem;
    .image-area {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4));
      object-fit: contain;
      min-height: auto;
      min-width: auto;
      cursor: pointer;
    }
  }
  .vx-card__title {
    overflow: hidden;
    width: 85%;
    h4 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .image-area-office {
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
  }
}
//プレビューのとき重なりの順序を変更するためz-indexを指定
.vue-lb-container {
  z-index: 100000;
}
</style>
